export default __webpack_public_path__ + "static/media/lumina.e6c146c1.png";